const KEY_LOCAL_STORAGE = 'previous-pages';

const getPreviousPages = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY_LOCAL_STORAGE));
    // eslint-disable-next-line
  } catch (e) {
    return null;
  }
};

const setPreviousPages = (pathName) => {
  const pages = getPreviousPages() ?? [];

  if (pathName && !pages.includes(pathName)) {
    pages.push(pathName);
  }

  if (pages.length > 0) {
    localStorage.setItem(KEY_LOCAL_STORAGE, JSON.stringify(pages));
  }

  return null;
};

export { getPreviousPages, setPreviousPages };
